import {
  ACCESS_TOKEN_COOKIE_NAME,
  ENV_VARIABLES,
  REFRESH_TOKEN_COOKIE_NAME,
} from '@web/constants';

import type { NextResponse } from 'next/server';

type AuthCookies = {
  accessToken: string;
  refreshToken?: string;
};

const REFRESH_TOKEN_TTL_DAYS = 14;
const REFRESH_TOKEN_MAX_AGE_SECONDS = REFRESH_TOKEN_TTL_DAYS * 24 * 60 * 60;

const baseCookieOptions = {
  httpOnly: true,
  secure: ENV_VARIABLES.IS_PRODUCTION ? true : false,
  sameSite: ENV_VARIABLES.IS_PRODUCTION ? ('none' as const) : ('lax' as const),
  path: '/',
};

const refreshCookieOptions = {
  ...baseCookieOptions,
  maxAge: REFRESH_TOKEN_MAX_AGE_SECONDS,
};

export const setAuthCookies = <T extends NextResponse>(
  response: T,
  tokens: AuthCookies,
) => {
  response.cookies.set(
    ACCESS_TOKEN_COOKIE_NAME,
    tokens.accessToken,
    baseCookieOptions,
  );

  if (tokens.refreshToken) {
    response.cookies.set(
      REFRESH_TOKEN_COOKIE_NAME,
      tokens.refreshToken,
      refreshCookieOptions,
    );
  }

  return response;
};

export const clearAuthCookies = <T extends NextResponse>(response: T) => {
  response.cookies.delete(ACCESS_TOKEN_COOKIE_NAME);
  response.cookies.delete(REFRESH_TOKEN_COOKIE_NAME);
  return response;
};
